import { configureStore } from "@reduxjs/toolkit";
import { Middleware, Reducer, ReducersMapObject, combineReducers } from "redux";

export * as classroomSelectors from "./selectors/classroom";
export * as localSelectors from "./selectors/local";
export * as monitoringSelectors from "./selectors/monitoring";
export * as globalSelectors from "./selectors/global";
export * as workbookSelectors from "./selectors/workbook";

export type { AppDispatch } from "../pubsub/client";

export function initializeStore<StateTypesMap>(
  reducers: ReducersMapObject,
  middleware: Middleware[],
) {
  // In redux@5 the combineReducers generic is the map-object type (M), not the
  // state shape, so passing a loose ReducersMapObject loses the state type.
  // Cast the result to the expected state shape.
  const rootReducer = combineReducers(reducers) as Reducer<StateTypesMap>;
  const store = configureStore({
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middleware),
    reducer: rootReducer,
  });
  return store;
}
